import { render, staticRenderFns } from "./PrazoEntregaEstados.vue?vue&type=template&id=1e9fca97"
import script from "./PrazoEntregaEstados.vue?vue&type=script&lang=js"
export * from "./PrazoEntregaEstados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports